import { render, staticRenderFns } from "./ChecklistBoolFieldModule.vue?vue&type=template&id=f7d36370&scoped=true"
import script from "./ChecklistBoolFieldModule.vue?vue&type=script&lang=ts"
export * from "./ChecklistBoolFieldModule.vue?vue&type=script&lang=ts"
import style0 from "./ChecklistBoolFieldModule.vue?vue&type=style&index=0&id=f7d36370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d36370",
  null
  
)

export default component.exports